import { Dropdown, MenuProps, Row } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useCallback, useMemo } from "react";
import { useDownloadAttachment } from "../../../../lib/hooks/useDownloadAttachment";
import FillableFormsService from "../../../../services/administration/fillableForms";
import { useDelete } from "../hooks/useDelete";

type TableActionsProps = {
  id: string;
  fileName: string;
  setOpenedItem: React.Dispatch<
    React.SetStateAction<string | null | undefined>
  >;
  reloadData: () => void;
};

export const TableActions = ({
  id,
  fileName,
  setOpenedItem,
  reloadData,
}: TableActionsProps) => {
  const { isLoading, onDownload } = useDownloadAttachment(FillableFormsService);

  const close = useCallback(() => setOpenedItem(undefined), [setOpenedItem]);

  const { onDelete } = useDelete(reloadData, close);

  const onDownloadClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      if (!isLoading) {
        e.stopPropagation();
        onDownload(id, fileName);
      }
    },
    [isLoading, onDownload, id, fileName],
  );

  const onEdit = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      setOpenedItem(id);
    },
    [id, setOpenedItem],
  );

  const onDeleteClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      onDelete(id);
    },
    [id, onDelete],
  );

  const items: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={onEdit}>Edit</Row>,
      },
      {
        key: "2",
        label: <Row onClick={onDownloadClick}>Download</Row>,
      },
      {
        key: "3",
        label: <Row onClick={onDeleteClick}>Delete</Row>,
      },
    ],
    [onEdit, onDownloadClick, onDeleteClick],
  );

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <EllipsisOutlined className="ml-1" onClick={(e) => e.stopPropagation()} />
    </Dropdown>
  );
};
